module.exports = __webpack_public_path__ + "img/PAGE01low.f64f4c9c.jpg";